import { render, staticRenderFns } from "./SyncQuickActions.vue?vue&type=template&id=8945fdbc&scoped=true"
import script from "./SyncQuickActions.vue?vue&type=script&lang=js"
export * from "./SyncQuickActions.vue?vue&type=script&lang=js"
import style0 from "./SyncQuickActions.vue?vue&type=style&index=0&id=8945fdbc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8945fdbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8945fdbc')) {
      api.createRecord('8945fdbc', component.options)
    } else {
      api.reload('8945fdbc', component.options)
    }
    module.hot.accept("./SyncQuickActions.vue?vue&type=template&id=8945fdbc&scoped=true", function () {
      api.rerender('8945fdbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/userSetting/union/components/SyncQuickActions.vue"
export default component.exports